/**
 * Generate a URL-safe share token for a published plan.
 *
 * 16 random bytes → base64url → 22-char string. The partial unique index on
 * `conversation_plans.share_token` catches the (astronomically unlikely)
 * collision and `SupabaseConversationPlanRepository.publish` surfaces it
 * as a `ValidationError` so the caller can retry.
 *
 * Uses Web Crypto (`globalThis.crypto.getRandomValues`) so the same module
 * can be imported from both the Node-side agent app and the Vite-bundled
 * web app without pulling `node:crypto` into the browser build.
 */
export function generateShareToken(): string {
  const bytes = new Uint8Array(16)
  globalThis.crypto.getRandomValues(bytes)
  return base64url(bytes)
}

function base64url(bytes: Uint8Array): string {
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!)
  }
  // btoa is available in both Node (since v16) and browsers.
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}
